/**
 * 广告位请求相关常量
 */

// 首页·分类导航相关
export const HOME_CATEGORY_NAV = {
  CODE: 'NEW_HOME_CATEGORY_2023',
  PARAMS: {
    Kind: 'IMAGE',
    PageIndex: 1,
    PageSize: 10
  }
}

// 首页·轮播图相关
export const HOME_BANNER = {
  CODE: 'NEW_HOME_BANNER',
  PARAMS: {
    Kind: 'IMAGE',
    PageIndex: 1,
    PageSize: 5
  }
}

// 首页·新品推荐相关
export const HOME_NEW_PRODUCT = {
  CODE: 'NEW_HOME_NEWPRODUCT',
  PARAMS: {
    Kind: 'PRODUCT',
    PageIndex: 1,
    PageSize: 4
  }
}

// 特价商品相关
export const HOME_SPECIAL_PRICE = {
  CODE: '7076065c2e224fa38c3e64c502dd2455',
  PARAMS: {
    ReferenceKind: 'specialactivity',
    PageIndex: 1,
    PageSize: 2
  }
}

// 分类功能编码 (保持原有的，因为这是另一个业务维度的常量)
export const CategoryFeatureCodes = {
  RECOMMEND: 'WNTJPBL',    // 为你推荐
  FRESH: 'SLSGPBL',       // 时令生鲜
  SNACKS: 'LSTCPBL',      // 零食特产
  DAILY: 'RYBHPBL',       // 日用百货
  BEAUTY: 'MZGHPBL',      // 美妆个护
  HEALTH: 'BJPBL',        // 滋补保健
  FOOD: 'LYTLPBL',        // 粮油调味
  CLOTHING: 'FSJFPBL',    // 服饰家纺
  WINE: 'MJMCPBL',        // 名酒茗茶
  DRINK: 'RYJSPBL',       // 乳饮酒水
  DIGITAL: 'SMJDPBL'      // 数码家电
}

// 分类名称映射 (保持原有的)
export const CategoryNames = {
  [CategoryFeatureCodes.RECOMMEND]: '为你推荐',
  [CategoryFeatureCodes.FRESH]: '时令生鲜',
  [CategoryFeatureCodes.SNACKS]: '零食特产',
  [CategoryFeatureCodes.DAILY]: '日用百货',
  [CategoryFeatureCodes.BEAUTY]: '美妆个护',
  [CategoryFeatureCodes.HEALTH]: '滋补保健',
  [CategoryFeatureCodes.FOOD]: '粮油调味',
  [CategoryFeatureCodes.CLOTHING]: '服饰家纺',
  [CategoryFeatureCodes.WINE]: '名酒茗茶',
  [CategoryFeatureCodes.DRINK]: '乳饮酒水',
  [CategoryFeatureCodes.DIGITAL]: '数码家电'
}

// 首页·分类导航（横向）列表相关
export const HOME_NAVIGATION = {
  CODE: 'NavigationName',
  PARAMS: {
    Kind: 'IMAGE',
    PageIndex: 1,
    PageSize: 30
  }
}

// 为了向后兼容，修改 AdvertCodes 结构
export const AdvertCodes = {
  // 保持原有的键名
  CATEGORY: HOME_CATEGORY_NAV.CODE,
  BANNER: HOME_BANNER.CODE,
  NEWPRODUCT: HOME_NEW_PRODUCT.CODE,
  SPECIALPRICE: HOME_SPECIAL_PRICE.CODE,
  NAVIGATION: HOME_NAVIGATION.CODE,
  
  // 新的键名（为未来使用）
  HOME_CATEGORY_NAV: HOME_CATEGORY_NAV.CODE,
  HOME_BANNER: HOME_BANNER.CODE,
  HOME_NEW_PRODUCT: HOME_NEW_PRODUCT.CODE,
  HOME_SPECIAL_PRICE: HOME_SPECIAL_PRICE.CODE,
  HOME_NAVIGATION: HOME_NAVIGATION.CODE
}

export const ADVERT_CODES = {
  // 已有代码...
  SLSG_BANNER2023: 'SLSG_BANNER2023'
}